export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/367d2948d3ecc1459e5c7207f173742a.png";